var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"app-button",class:("--" + _vm.theme),style:({
    'height': (_vm.height + "px"),
    'max-width': (_vm.maxWidth + "px")
  }),on:{"click":function($event){return _vm.$emit('clicked')}}},[_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }